import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import InputMask from 'react-input-mask';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import Province from 'modules/common/address/Province';
import Municipality from 'modules/common/address/Municipality';
import CmsContext from 'context/CmsContext';
import moment from 'moment';
import Select from 'react-select';
import { reactSelectCustomStyle } from 'helper';

import * as actions from '../action';
import * as c from '../constant';

function UpdateModal({
  createInput,
  createInputNumber,
  createSelect,
  updateCdl,
  showTransaction,
  formData,
  updateList,
  setFormData,
  transactId,
  validId,
  updating,
  moduleId,
  getTransactionList,
  getBarangayList,
  barangayList,
  getBusinessNaturesList,
  businessNaturesList,
  getBusinessLinesList,
  businessLinesList,
  transactionInfo
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_CEDULA = cmsContext.findByType('CEDULA');

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      module_id: moduleId,
    };
    updateCdl(moduleId, args, () => {
      setModal({ isOpen: false });
      showTransaction(transactId);
      getTransactionList({
        transaction_type: "CORPORATION"
      });
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const args = {
        ...updateList,
        valid_id_to_present: validId,
      };
      setFormData(_.pick(args, _.keys(c.CEDULA_EDIT_FORM)));
    }
  };

  useEffect(() => {
    getBusinessNaturesList();
    getBusinessLinesList();
    getBarangayList({
      municipality_code: _.get(
        updateList,
        'municipality_code',
      ),
      per_page: 50000
    });
  }, []);

  useEffect(() => {
    setFormData({
      ...formData,
      cedula_amount_1: (_.get(formData, 'total_assessed_value_of_real_property') / 2500),
      cedula_amount_2: (_.get(formData, 'total_earnings_from_business') / 2500),
      business_line_id: +_.get(
        updateList,
        'business_line_id'
      ),
      nature_of_business_id: +_.get(
        updateList,
        'nature_of_business_id'
      ),
    })
  }, [formData.total_assessed_value_of_real_property, formData.total_earnings_from_business, ])

  useEffect(() => {
    onSetFormData();
  }, {});

  const commonValidation = {
    tin: 'required|tax_payer_account_number',
  }

  const validateForm = useFormValidator(
    formData,
    commonValidation,
  );

  useEffect(() => {
    validateForm.onSetObjectRules(commonValidation)
  }, [])

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const handleOnChangeDate = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const createDropdown = list => {
    const newList = [];
    list.map(data => {
      return newList.push({
        label: data.attributes.name,
        value: data.attributes.code,
      });
    });
    return newList;
  };

  /* eslint-disable eqeqeq */
  const getSelectedOptions = (list, value) => {
    return createDropdown(list).find(x => x.value == value) || {};
  };

  const handleBarangaySelect = e => {
    setFormData({
      ...formData,
      barangay_code: e.value,
    });
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const selectBusinessNatureId = businessNaturesList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const findBusinessNatureValue =
    selectBusinessNatureId.find(
      item => +_.get(formData, 'nature_of_business_id') === +item.id
    ) || '';

  const selectBusinessLineId = businessLinesList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const findBusinessLineValue =
    selectBusinessLineId.find(
      item => +_.get(formData, 'business_line_id') === +item.id
    ) || '';
  

  const handleNatureDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });

    getBusinessLinesList({ business_nature_id: e.value });
  };

  const handleLineDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const handleOnChangeProvince = e => {
    setFormData({
      ...formData,
      place_of_registration_province_code: e ? e.fullInfo.attributes.code : '',
    });
  };

  const handleOnChangeMunicipality = e => {
    setFormData({
      ...formData,
      place_of_registration_municipality_code: e ? e.fullInfo.attributes.code : '',
      place_of_registration: e ? e.label : ''
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <label className="col-12 form-group">
            Document Owner&apos;s Information
          </label>
          {/* <div className="col-6 form-group">
            {createInput({ key: 'president_authorized_representative', label: 'President/Authorized Representative:' })}
          </div> */}
          <div className="col-6 form-group">
            {createInput({ key: 'authorized_representative_first_name', label: 'First Name:' })}
          </div>
          <div className="col-6 form-group">
            {createInput({ key: 'authorized_representative_middle_name', label: 'Middle Name:' })}
          </div>
          <div className="col-6 form-group">
            {createInput({ key: 'authorized_representative_last_name', label: 'Last Name:' })}
          </div>
          <div className="col-6 form-group">
            {createSelect(
              {
                required: true,
                placeholder: 'Extension Name',
                key: 'extension_name',
                label: 'Extension Name',
              },
              c.EXTENSION_NAMES
            )}
          </div>
          <div className="col-6 form-group">
            {createInput({ key: 'name_of_corporation_partnership', label: 'Name of Corporation/Partnership:' })}
          </div>
          <div className="col-6 pt-1">
            <label className="form-label">Barangay:
            </label>
            <div>
              <Select
                options={createDropdown(barangayList)}
                placeholder="Select Barangay"
                value={getSelectedOptions(barangayList, formData.barangay_code)}
                onChange={e => {
                  handleBarangaySelect(e)
                }}
              />
            </div>
          </div>
          <div className="col-6 form-group">
            {createInput({ key: 'street', label: 'Street:' })}
          </div>
          <div className="col-6 form-group">
            <label className="form-label">Date of Registration:</label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('date_of_registration')}
              value={
                `${moment(_.get(formData, 'date_of_registration')).format(
                  'MM-DD-YYYY HH:mm'
                )}:00` || ''
              }
              maxDate={new Date()}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">Place of Registration</label>  
          </div>
          <div className='col-6 form-group'>
            <label className="form-label mb-0">Province</label>
            <Province
              styles={reactSelectCustomStyle}
              name="place_of_registration_province_code"
              value={
                _.get(formData, 'place_of_registration_province_code') || ''
              }
              regionCode={_.get(transactionInfo, 'included.module.attributes.region_code')}
              onChange={e => {handleOnChangeProvince(e)}}
            />
          </div>
          <div className='col-6 form-group'>
            <label className="form-label mb-0">City/Municipality</label>
            <Municipality
              styles={reactSelectCustomStyle}
              name="place_of_registration_municipality_code"
              value={
                _.get(formData, 'place_of_registration_municipality_code') || ''
              }
              regionCode={_.get(transactionInfo, 'included.module.attributes.region_code')}
              provinceCode={_.get(formData, 'place_of_registration_province_code') || ''}
              onChange={e => {handleOnChangeMunicipality(e)}}
            />
          </div>
          <div className="col-6 form-group">
            <label htmlFor="last_name" className="form-label">TIN / Tax Payer Account No.: {validateForm.renderMessage('tin')}</label>
            <InputMask
              className="form-control"
              mask="999-999-999-99999"
              alwaysShowMask
              type="text"
              name="tin"
              onChange={handleOnChange}
              value={_.get(formData, 'tin')}
            />
          </div>
          {/* <div className="col-6 form-group">
            {createSelect(
              {
                key: 'valid_id_to_present',
                label: 'Valid ID:',
              },
              c.VALID_IDS
            )}
          </div> */}
          <div className="col-6 form-group">
            <label className="form-label">
              Business Nature:
            </label>
            <Select
              options={selectBusinessNatureId}
              placeholder="Select Business Nature"
              value={findBusinessNatureValue}
              onChange={handleNatureDropDownChange('nature_of_business_id')}
            />
          </div>
          <div className="col-6 form-group">
            <label className="form-label">
              Business Line:
            </label>
            <Select
              options={selectBusinessLineId}
              placeholder="Select Business Line"
              value={findBusinessLineValue}
              onChange={handleLineDropDownChange('business_line_id')}
            />
          </div>
          <div className="col-12 form-group">
            <label className='form-label'>
              Cedula / Community Tax Certificate
            </label>
          </div>
          <div className="col-12 form-group">
            <label className='form-label'>
              {_.get(
                CMS_CEDULA,
                'CEDULA_CORPORATION_DESCRIPTION_1'
              )}
              {/* Total assessed value of Real Property */}
            </label>
          </div>
          <div className="col-6 form-group">
            {createInputNumber({ key: 'total_assessed_value_of_real_property', label: 'Taxable Amount:' })}
          </div>
          <div className="col-6 form-group">
            {createInputNumber({ key: 'cedula_amount_1', label: 'Cedula Amount:', 
            // isReadOnly: true
            })}
          </div>
          <div className="col-12 form-group">
            <label className='form-label'>
              {_.get(
                CMS_CEDULA,
                'CEDULA_CORPORATION_DESCRIPTION_1'
              )}
              {/* Total gross earnings from business */}
            </label>
          </div>
          <div className="col-6 form-group">
            {createInputNumber({ key: 'total_earnings_from_business', label: 'Taxable Amount:' })}
          </div>
          <div className="col-6 form-group">
            {createInputNumber({ key: 'cedula_amount_2', label: 'Cedula Amount:', 
            // isReadOnly: true
            })}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  createInput: PropTypes.instanceOf(Function).isRequired,
  createInputNumber: PropTypes.instanceOf(Function).isRequired,
  createSelect: PropTypes.instanceOf(Function).isRequired,
  updateList: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  updateCdl: PropTypes.instanceOf(Function).isRequired,
  moduleId: PropTypes.string.isRequired,
  transactId: PropTypes.string.isRequired,
  validId: PropTypes.string.isRequired,
  updating: PropTypes.bool.isRequired,

  getBarangayList: PropTypes.instanceOf(Function).isRequired,
  barangayList: PropTypes.instanceOf(Array).isRequired,
  getBusinessNaturesList: PropTypes.instanceOf(Function).isRequired,
  businessNaturesList: PropTypes.instanceOf(Array).isRequired,
  getBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  businessLinesList: PropTypes.instanceOf(Array).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_TRANSACTION) > -1,
  barangayList: _.get(api, `${c.GET_BARANGAYS}.list`) || [],
  businessNaturesList: _.get(api, `${c.GET_BUSINESS_NATURES_LIST}.list`) || [],
  businessLinesList: _.get(api, `${c.GET_BUSINESS_LINES_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
